
import axiosInstance from './../../axiosInstance';
import {
    ADD_ASSIGN_USERS_URL,
    CREATE_ASSIGN_USERS_URL,
    CREATE_CLIENT_GROUP_URL, DESTROY_CLIENT_GROUP_URL, GET_ALL_CLIENT_GROUP_URL, GET_ALL_STAFF_URL, GET_ASSIGN_USERS_LISTING_URL, GET_ASSIGN_USER_DROPDOWN_URL, GET_CLIENTS_GROUPS_CHOICE_URL, GET_CLIENT_GROUP_DETAILS_URL,
    GET_ASSIGN_STAFF_LOG_URL,
    TOGGLE_ASSIGN_USERS_URL
} from './../../api/index';
import { SINGLE_ASSIGN_GROUP_USERS } from '../../routeNames';

// client 
export const createClientGroup = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_CLIENT_GROUP_URL, props.formData)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAllClientGroups = (page, limit, search) => onResponse => {
    try {
        let data = search ? search : ""
        axiosInstance.get(GET_ALL_CLIENT_GROUP_URL, {
                        params: {
                            page: page,
                            limit: limit,
                            search: data
                        }
                        })

            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getClientGroupDetails = (id) => onResponse => {
    try {
        axiosInstance.get(GET_CLIENT_GROUP_DETAILS_URL + '?client_group_id=' + id)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const deleteClientGroup = (id) => onResponse => {
    try {
        axiosInstance.delete(DESTROY_CLIENT_GROUP_URL, {
            data: { client_group_id: id }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAllStaffs = () => onResponse => {
    try {
        axiosInstance.get(GET_ALL_STAFF_URL)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const createAssignUsers = (values, id, staff) => onResponse => {
    try {
        axiosInstance.post(CREATE_ASSIGN_USERS_URL, {
            staff: values,
            client_group: id,
            staff_in_group: staff
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getGroupsForClient = () => onResponse => {
    try {
        axiosInstance.get(GET_CLIENTS_GROUPS_CHOICE_URL)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSingleAssignGroupUser = (id) => onResponse => {
    try {
        axiosInstance.get(SINGLE_ASSIGN_GROUP_USERS + '?client_group_id=' + id)

            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getAssignUsersListingDetails = (page, limit,sortKey,sortOrder,id,assigned_user,assigned_by,assigned_date_str,is_active) => onResponse => {
    try {
        axiosInstance.get(GET_ASSIGN_USERS_LISTING_URL + '?client_group=' + id+'&assigned_user='+assigned_user+'&assigned_by='+assigned_by+'&assigned_date='+assigned_date_str+'&is_active='+is_active+'&page='+page+'&limit='+limit+'&sort_key='+sortKey+'&sort_order='+sortOrder)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getAssignStaffLogDetails = (props) => onResponse => {
    try {
        axiosInstance.get(GET_ASSIGN_STAFF_LOG_URL, {
            params: {
                assigned_user: props?.assigned_user||"",
                assigned_by: props?.assigned_by||"",
                assigned_date: props?.assigned_date||"",
                page: props?.page,
                limit: props?.perPage,
                client_group: props?.pk,
            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getAssignUserDropdown = (id) => onResponse => {
    try {
        axiosInstance.get(GET_ASSIGN_USER_DROPDOWN_URL + '?client_group=' + id)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const addAssignUsers = (client_group, staff) => onResponse => {
    try {
        axiosInstance.post(ADD_ASSIGN_USERS_URL, {
            client_group: client_group,
            staff: staff
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const toggleAssignUsers = (client_group, staff, reason) => onResponse => {
    try {
        axiosInstance.post(TOGGLE_ASSIGN_USERS_URL, {
            client_group: client_group,
            staff: staff,
            reason: reason
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};